//https://www.npmjs.com/package/vuetify-dialog

export const notification = (dialog, msg) => {
    dialog(msg, {
        position: 'top-right',
        timeout: 2000,
    });
};
